<template>
  <footer class="flex-shrink-1">
    <div class="w-full bg-[#54586a] py-4 shadow">
      <div class="container mx-auto px-4 flex flex-col md:flex-row items-center justify-between space-y-3 md:space-y-0">
        
        <!-- Left: Copyright -->
        <p class="text-white text-center md:text-left">
          &copy; Perfect Storm Comics & Games {{ new Date().getFullYear() }}
        </p>
        
        <!-- Right: Footer Nav -->
        <div class="flex flex-wrap justify-center md:justify-end gap-4 text-sm">
          <router-link to="/" class="text-white hover:underline">Home</router-link>
          <router-link to="/search" class="text-white hover:underline">Search</router-link>
          <router-link to="/faqs" class="text-white hover:underline">FAQs</router-link>
          <router-link to="/how-to-pack-ship" class="text-white hover:underline">How To: Pack/Ship</router-link>
          <router-link to="/collection-estimate" class="text-white hover:underline">Collection Estimate</router-link>
          <router-link to="/sign-up" class="text-white hover:underline">Sign Up</router-link>
          <router-link to="/terms" class="text-white hover:underline">Terms</router-link>
          <router-link to="/privacy" class="text-white hover:underline">Privacy Policy</router-link>
          <a href="https://perfectstormmtg.net/" target="_blank" rel="noopener noreferrer" class="text-white hover:underline">
            About Us
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
// no script needed
</script>
